import { AlertService } from 'app/services/alert.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DateAdapter, MatPaginator, MatSort, MatTableDataSource, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus } from '../../../../models/messages';
import { RiesgoService } from '../../../../services/riesgo/riesgo.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { Fondo } from '../../../../models/Fondo';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login/login.service';
import { HttpErrorResponse } from '@angular/common/http';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-listado-fondos',
  templateUrl: './listado-fondos.component.html',
  styleUrls: ['./listado-fondos.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus, DatePipe, DecimalPipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class ListadoFondosComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns = ['checked', 'idFondo', 'Nombre_Fondo', 'Moneda', 'Monto_Fondo',
    'Monto_Fondo_Disponible', 'Monto_Fondo_Ejecutado', 'Estado'];
  pageSizeOptions = [10, 20, 30, 50, 100, 200];
  dataSource: any;
  IP: string = '';
  fechaActual: string;
  readonly CANAL_AUDITORIA: string = 'W';
  userActive: any;
  fondos: any[] = [];
  fondosTemp: any[] = [];
  estadosFondo: any[] = [];
  monedasFondo: any[] = [];
  fondo: Fondo;
  formFondo: FormGroup;
  nombreFilter: FormControl = new FormControl('');
  estadoFilter: FormControl = new FormControl('');
  monedaFilter: FormControl = new FormControl('');
  filterValues: any = {
    nombre: '',
    estado: '',
    moneda: ''
  }
  value: any;
  loading: boolean = false;
  subLista: Subscription[] = [];
  subListaFondos: Subscription = new Subscription();

  constructor(
    private riesgoService: RiesgoService,
    private formBuilder: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private alertService: AlertService
  ) {
    //this.IP = JSON.parse(sessionStorage.getItem('PUBLIC-IP')).ip ? JSON.parse(sessionStorage.getItem('PUBLIC-IP')).ip : '192.168.1.1';
    this.IP = '192.168.1.1';
    this.userActive = JSON.parse(sessionStorage.getItem('UserActive'));
    this.fechaActual = new Date().toISOString().split('T')[0];

    this.estadosFondo = this.riesgoService.Estados;
    this.monedasFondo = this.riesgoService.Monedas;

    this.nombreFilter.valueChanges.subscribe(
      status => {
        this.filterValues.nombre = status;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );

    this.estadoFilter.valueChanges.subscribe(
      status => {
        this.filterValues.estado = status;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );

    this.monedaFilter.valueChanges.subscribe(
      source => {
        this.filterValues.moneda = source;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
  }

  ngOnInit() {
    this.monedasFondo.forEach(moneda => moneda.value = (moneda.key === '') ? 'Todos' : moneda.value);
    this.listadoFondos();
  }

  ngOnDestroy() {
    this.subLista.forEach(sub => { sub.unsubscribe(); });
  }

  /**
  * Función para obtener todos los fondos desde la BD.
  */
  listadoFondos() {
    this.loading = true;
    this.subListaFondos = this.riesgoService.obtenerFondos().subscribe(
      (resFondos: any) => {
        this.fondos = resFondos;
        this.loading = false;
        this.fondos.forEach((f: Fondo) => {
          for (const iterator of this.monedasFondo) {
            if (iterator.key == f.Moneda.toString()) {
              f.Moneda_Symbol = iterator.symbol;
            }
          }
        });
        this.dataSource = new MatTableDataSource(this.fondos);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.crearFiltro();
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        Swal.fire({
          title: 'Error',
          html: this.alertService.createTextError(err, 'Fondos no obtenidos. <br/>'),
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subListaFondos);
  }

  /**
  * Función para crear un filtro sobre el listado de fondos existentes (evitando la llamada al service).
  */
  private crearFiltro(): (fondo: Fondo, filter: string) => boolean {
    return function (fondo: Fondo, filter: string): boolean {
      let searchTerms = JSON.parse(filter);
      return fondo.Nombre_Fondo.toLowerCase().indexOf(searchTerms.nombre.toLowerCase()) != -1
        && fondo.Moneda.toString().indexOf(searchTerms.moneda) != -1
        && fondo.Estado.indexOf(searchTerms.estado) != -1;
    }
  }

  /**
  * Función para abrir el formulario de registro de fondos.
  */
  crearNuevoFondo() {
    this.riesgoService.flagCrear = true;
    this.riesgoService.flagEditar = false;
    this.riesgoService.flagVer = false;
    this.loginService.clickGuard = true;
    this.router.navigate(['/fondo/concentracion/fondos/nuevo']);
  }

  /**
  * Función para abrir el formulario de actualización de fondos.
  */
  editarFondo(fondo: any) {
    this.riesgoService.dataFondo = fondo;
    this.riesgoService.flagCrear = false;
    this.riesgoService.flagEditar = true;
    this.riesgoService.flagVer = false;
    this.loginService.clickGuard = true;
    this.router.navigate(['/fondo/concentracion/fondos/nuevo']);
  }

  /**
  * Función para abrir el formulario de detalle de fondos.
  */
  verDetalleFondo(fondo: any) {
    this.riesgoService.dataFondo = fondo;
    this.riesgoService.flagCrear = false;
    this.riesgoService.flagEditar = false;
    this.riesgoService.flagVer = true;
    this.loginService.clickGuard = true;
    this.router.navigate(['/fondo/concentracion/fondos/nuevo']);
  }

  /**
  * Función para preparar la data a enviar para el cambio de estado del fondo (activar, desactivar).
  */
  armarBodyFondo(fondo: Fondo, estado: string) {
    this.formFondo = this.formBuilder.group({
      IdFondo: fondo.idFondo,
      Estado: estado,
      Usuario: this.userActive.Usuario,
      ModificacionFecha: this.fechaActual,
      ModificacionCanal: this.CANAL_AUDITORIA,
      IP: this.IP
    });
  }

  /**
  * Función que llama al service de cambio de estado del fondo. 
  */
  cambiarEstadoFondo(fondo: Fondo, estado: string) {
    let textSwal = (estado == 'A') ? 'Activar el fondo?' : 'Dar de baja el fondo?';
    let textConfirmBtnSwal = (estado == 'A') ? 'Si, activar' : 'Si, dar de baja';
    Swal.fire({
      text: textSwal,
      type: 'question',
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      showConfirmButton: true,
      confirmButtonText: textConfirmBtnSwal,
      allowOutsideClick: false,
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {

        this.armarBodyFondo(fondo, estado);

        Swal.fire({
          title: 'Espere',
          text: 'Guardando los cambios...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();

        this.riesgoService.cambiarEstadoFondo(this.formFondo.getRawValue(), fondo.idFondo).subscribe(
          () => {
            let textConfirmService = (estado == 'A') ? '¡El fondo N° '.concat(fondo.idFondo.toString(), ' ha sido activado!') : '¡El fondo N° '.concat(fondo.idFondo.toString(), ' se ha deshabilitado!');
            Swal.fire({
              title: 'Éxito',
              text: textConfirmService,
              type: 'success',
              allowOutsideClick: false,
              heightAuto: false
            });

            this.listadoFondos();
          },
          (err: HttpErrorResponse) => {
            Swal.fire({
              title: 'Error',
              html: (estado == 'A') ? this.alertService.createTextError(err, 'Hubo un error a la hora de activar el fondo. <br/>') : this.alertService.createTextError(err, 'Hubo un error a la hora de deshabilitar el fondo. <br/>'),
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
          }
        );
      }
    });
  }

}
